<div class="item {{ signerItem.class }}">
  <div class="item-head">
    @if (!signer.action?.name) {
      <span class="item-head-contact">{{ 'signature.creator' | translate }}</span>
    } @else {
      <span class="item-head-contact">{{ documentService.translateRole(signer.action) }}</span>

      @if (signer.delivery_method) {
        <span class="ml-1 monster__badge badge-XS badge-neutral">
          <i class="far fa-{{ signerItem.deliveryMethodIcon }}"></i>
          {{ 'documents.deliveryMethod.' + (signer.delivery_method | lowercase) | translate }}
        </span>
      }

      @if (signerItem.isSignerIcpBrasil && isCountryBR) {
        <span class="icp">
          <img src="assets/logo-icp-side.png" />
        </span>
      }

      @if (signerItem.status.text) {
        <span class="ml-auto monster__badge badge-S badge-{{ signerItem.status.badge }}">
          <i class="far fa-{{ signerItem.status.icon }}"></i>
          {{ 'documents.statusCard.' + signerItem.status.text | translate }}
        </span>
      }
    }

    @if (signerItem.shouldShowOptionsToggle.pendingBlock) {
      <div class="item-head-options" appDropdown placement="bottom-right">
        <button type="button" class="dropdown__toggle-control dropdown__toggle-control--icon-end dropdown__toggle-control--filled-white" [id]="'signer-dropdown-' + signer.public_id" appDropdownToggle>
          <span>{{ 'documents.options' | translate }}</span>
          <i class="far fa-ellipsis-v"></i>
        </button>

        <div [attr.aria-labelledby]="'signer-dropdown-' + signer.public_id" appDropdownMenu>
          @if (!signer.user || documentAuthorId !== signer?.user?.id) {
            @if (signer.email && !signerItem.signatureStatus.isSigned) {
              <button type="button" (click)="updateClick.emit(signer)" appDropdownItem>
                <i class="fa-regular fa-edit"></i>
                {{ 'signature.changeEmail' | translate }}
              </button>
            }

            @if (signer.email || signer.user?.phone) {
              @if (!signerItem.signatureStatus.isSigned) {
                <button type="button" (click)="$any($event.target).classList.add('disabled'); resendSignaturesClick.emit(signer)" appDropdownItem>
                  <i class="fa-regular fa-redo"></i>
                  {{ 'signature.resend' | translate }}
                </button>
              }

              @if (signerItem.signatureStatus.isPendingIgnoreEmailErrors) {
                <button type="button" (click)="createLinkClick.emit(signer)" appDropdownItem>
                  <i class="fal fa-link"></i>
                  {{ 'signature.signatureLink' | translate }}
                </button>
              }
            }

            @if (signer.user?.birthday && signer.user?.cpf && (signer.email || signer.user.phone) && !signerItem.signatureStatus.isSigned && !hideCPF) {
              <button type="button" (click)="consultCPFClick.emit(signer)" appDropdownItem>
                <i class="fa-regular fa-id-card"></i>
                {{ 'signature.checkCPF' | translate }}
              </button>
            }

            @if (signerItem.hasVerifiableData) {
              <button type="button" (click)="verifyBiometryClick.emit(signer)" appDropdownItem>
                <i class="fal fa-user"></i>
                {{ 'signature.biometricValidation' | translate }}
              </button>
            }
          }

          @if (!signerItem.signatureStatus.isSigned) {
            <button type="button" class="dropdown__item--danger" (click)="deleteClick.emit(signer)" appDropdownItem>
              <i class="fa-regular fa-user-minus"></i>
              {{ 'signature.removeSignatory' | translate }}
            </button>
          }
        </div>
      </div>
    } @else if (signerItem.shouldShowOptionsToggle.signedBlock) {
      <div class="item-head-options" appDropdown placement="bottom-right">
        <button type="button" class="dropdown__toggle-control dropdown__toggle-control--icon-end dropdown__toggle-control--filled-white" [id]="'signer-dropdown-' + signer.public_id" appDropdownToggle>
          <span>{{ 'documents.options' | translate }}</span>
          <i class="far fa-ellipsis-v"></i>
        </button>
        <div [attr.aria-labelledby]="'signer-dropdown-' + signer.public_id" appDropdownMenu>
          @if (signer.user?.birthday && signer.user?.cpf && !hideCPF) {
            <button type="button" (click)="consultCPFClick.emit(signer)" appDropdownItem>
              <i class="fa-regular fa-id-card"></i>
              {{ 'signature.checkCPF' | translate }}
            </button>
          }

          @if (signerItem.hasVerifiableData) {
            <button type="button" (click)="verifyBiometryClick.emit(signer)" appDropdownItem>
              <i class="fal fa-user"></i>
              {{ 'signature.biometricValidation' | translate }}
            </button>
          }

          @if (signer.certificate) {
            <button type="button" (click)="openCertificateModal(signer.certificate.payload)" appDropdownItem>
              <i class="fa-regular fa-file-certificate"></i>
              {{ 'documents.viewCertificate' | translate }}
            </button>
          }
        </div>
      </div>
    }
  </div>

  <div class="item-content">
    <app-avatar [seed]="signerItem.avatarSeed" [forceAvatar]="forceAvatar" class="mr-1"></app-avatar>

    <div class="item-content-data">
      @if (!signer.certificate) {
        <div class="item-content-top">
          <div class="item-content-name" [class.no-name]="!signer.configs?.overwrite_name && !signer.user?.name && !signer.name">
            {{ signer.configs?.overwrite_name || signer.user?.name || signer.name || signer.email || signer.user?.phone }}

            @if (signerItem.isAlreadyVerified && signerItem.signatureStatus.isSigned) {
              <i class="fal fa-shield-check" [ngbTooltip]="tooltipSignatureVerificationSigned"></i>
            }
          </div>

          @if (!!signerItem.company) {
            <div class="item-content-corp">
              <i class="far fa-building"></i>
              <span class="item-content-company">{{ signerItem.company }}</span>
            </div>
          }
        </div>

        <div class="item-content-bottom">
          @if (!hideCPF && signer.user?.cpf && signer.action?.name) {
            <div class="item-content-id">
              {{ signer && !signerItem.signatureStatus.isPending ? signer.user.cpf : cpfMask(signer.user.cpf) }}
            </div>
          }

          @if (signer.configs?.overwrite_date) {
            <div class="item-content-date">
              {{ dateService.normalizeDate(signer.configs?.overwrite_date) }}
            </div>
          } @else if (!hideBirthdate && signer.user?.birthday && signer.action?.name) {
            <div class="item-content-date">
              {{ signer && !signerItem.signatureStatus.isPending ? dateService.normalizeDate(signer.user.birthday) : birthdayMask(dateService.normalizeDate(signer.user.birthday)) }}
            </div>
          }
        </div>

        @if (!signer.email && signer.link?.id && signerItem.signatureStatus.isPending && isAllowedUser) {
          <div class="configuration-value">
            <input type="text" class="configuration-value-show" [value]="appService.signerLink(signer.link)" readonly #webhookInputElement />
            <div class="configuration-value-copy" (click)="copySignatureLink()" [ngxClipboard]="webhookInputElement"></div>
          </div>
        }
      } @else {
        <div class="item-content-name">{{ signer.certificate.name }}</div>

        @if (signer.certificate.document) {
          <div class="item-content-id">{{ formatCpfCnpj(signer.certificate.document) }}</div>
          <div class="item-content-cert">{{ isCpf(signer.certificate.document) ? ('profile.cpf' | translate) : ('profile.cnpj' | translate) }} {{ certificateTypes[signer.certificate.type] }}</div>
        }

        <div class="item-content-links">
          @if (signer.certificate.email) {
            <a class="monster__badge badge-S badge-neutral" [href]="'mailto:' + (signer.certificate.email | lowercase)">
              <i class="far fa-envelope"></i>
              {{ signer.certificate.email | lowercase }}
            </a>
          }
        </div>
      }
    </div>
  </div>

  @if (!signer.certificate) {
    <div class="item-content-links">
      @if (signer.email) {
        <a class="monster__badge badge-S badge-neutral" [href]="'mailto:' + signer.email">
          <i class="far fa-envelope"></i>
          {{ signer.email }}
        </a>
      }

      @if (signer.user?.phone) {
        <a class="monster__badge badge-S badge-neutral" href="javascript:void(0)">
          <i class="far fa-phone"></i>
          {{ signer.user.phone | phone$ | async }}
        </a>
      }
    </div>
  }

  <div class="item-info-holder">
    @for (step of signer | toSignatureSteps: { documentAuthorId: documentAuthorId, signerHasFieldsToFill: signerHasFields }; track $index) {
      <div class="item-info" [class.active]="step.isActive">
        <div class="item-info-icon">
          @if (step.status === SignatureStepStatus.success) {
            <i class="far fa-check"></i>
          }

          @if (
            step.status === SignatureStepStatus.bounce ||
            step.status === SignatureStepStatus.deferred ||
            step.status === SignatureStepStatus.blocked ||
            step.status === SignatureStepStatus.dropped ||
            step.status === SignatureStepStatus.spamreport ||
            step.status === SignatureStepStatus.cellSMS ||
            step.status === SignatureStepStatus.cellWhats
          ) {
            <i class="far fa-exclamation-triangle icon-yellow"></i>
          }

          @if (step.status === SignatureStepStatus.failed) {
            <i class="far fa-xmark"></i>
          }

          @if (step.status === SignatureStepStatus.unapproved) {
            <i class="far fa-exclamation-circle"></i>
          }

          @if (
            ![
              SignatureStepStatus.cellSMS,
              SignatureStepStatus.cellWhats,
              SignatureStepStatus.success,
              SignatureStepStatus.failed,
              SignatureStepStatus.deferred,
              SignatureStepStatus.blocked,
              SignatureStepStatus.dropped,
              SignatureStepStatus.spamreport,
              SignatureStepStatus.bounce,
              SignatureStepStatus.unapproved
            ].includes($any(step.status))
          ) {
            <i class="far fa-clock"></i>
          }
        </div>

        <div class="item-info-content">
          <div class="item-info-title">
            @switch (step.type) {
              @case (SignatureStepType.creation) {
                {{ 'signature.createdDocument' | translate }}
              }

              @case (SignatureStepType.emailDelivery) {
                @switch (step.status) {
                  @case (SignatureStepStatus.waiting) {
                    @if (signerItem.isWaitingSortable) {
                      {{ 'signature.awaitingOtherSignatories' | translate }}
                    } @else {
                      @if (!signer.email_events?.sent) {
                        {{ 'signature.deliverySending.' + (signer.delivery_method | lowercase) | translate }}
                      } @else {
                        {{ 'signature.deliverySent.' + (signer.delivery_method | lowercase) | translate }}
                      }
                    }
                  }

                  @case (SignatureStepStatus.success) {
                    {{ 'signature.deliveryReceived.' + (signer.delivery_method | lowercase) | translate }}
                  }

                  @case (SignatureStepStatus.failed) {
                    @if (!hasMailError()) {
                      {{ 'signature.deliveryNotReceived.' + (signer.delivery_method | lowercase) | translate }}
                    }
                  }

                  @case (SignatureStepStatus.cellWhats) {
                    {{ 'signature.notReceivedWhatsApp' | translate }}
                  }

                  @case (SignatureStepStatus.cellSMS) {
                    {{ 'signature.notReceivedSMS' | translate }}
                  }
                }
              }

              @case (SignatureStepType.openEmail) {
                @if (step.status === SignatureStepStatus.waiting) {
                  {{ 'signature.deliveryNotOpenedYet.' + (signer.delivery_method | lowercase) | translate }}
                } @else if (step.status === SignatureStepStatus.success) {
                  {{ 'signature.deliveryOpened.' + (signer.delivery_method | lowercase) | translate }}
                }
              }

              @case (SignatureStepType.toSee) {
                @if (step.status === SignatureStepStatus.waiting) {
                  {{ 'signature.notViewedYet' | translate }}
                } @else if (step.status === SignatureStepStatus.success) {
                  {{ 'signature.openedDocument' | translate }}
                }
              }

              @case (SignatureStepType.toSign) {
                @if (step.status === SignatureStepStatus.waiting) {
                  {{ 'signature.notYetSubject.' + (signerHasFields ? 'filledOut.' : '') + (signer.action.name | lowercase) | translate }}
                } @else if (step.status === SignatureStepStatus.success || step.status === SignatureStepStatus.unapproved) {
                  {{ 'signature.actionDocumentSubject.' + (signerHasFields ? 'filledOut.' : '') + (signer.action.name | lowercase) | translate }}
                  @if (!signer.certificate) {
                    @if (isAllowedUser && step.status === SignatureStepStatus.success) {
                      @if (signerItem.isSignatureVisible) {
                        <div class="item-info-label active" [ngbTooltip]="tooltipSignatureVisible">
                          <i class="fal fa-signature"></i>
                          {{ 'signature.visibleSignature' | translate }}
                        </div>
                      } @else if (!isDynamicDocument) {
                        <div class="item-info-label nofield" [routerLink]="[router.url + '/campos']" [ngbTooltip]="tooltipSignatureInvisible">
                          <i class="fa-regular fa-eye-slash"></i>
                          {{ 'signature.invisibleSignature' | translate }}
                        </div>
                      }
                    }

                    @if (signerItem.isVerifiedBy.sms && !signerItem.hasVerifiableData) {
                      <div class="item-info-label biometry" [ngbTooltip]="tooltipSignatureVerificationSigned">
                        <i class="fal fa-shield-check"></i>
                        {{ 'signature.additionalVerification' | translate }}
                      </div>
                    }

                    @if ((isAllowedUser || !signerItem.signatureStatus.isUnnapproved) && signerItem.hasVerifiableData && canValidateBiometry) {
                      <div
                        class="item-info-label biometry"
                        [ngClass]="{ unapproved: signerItem.signatureStatus.isUnnapproved }"
                        [ngbTooltip]="signerItem.signatureStatus.isUnnapproved ? null : tooltipSignatureVerificationSigned"
                        (click)="verifyBiometryClick.emit(signer)"
                        style="cursor: pointer"
                      >
                        @if (signerItem.signatureStatus.isUnnapproved) {
                          {{ 'signature.additionalVerificationClickHere' | translate }}
                        } @else {
                          <i class="fal fa-shield-check"></i>
                          {{ 'signature.additionalVerification' | translate }}
                        }
                      </div>
                    }
                  }
                }

                @if (step.status === SignatureStepStatus.failed) {
                  {{ getRejectionText(signer) | translate }}

                  @if (!signer.certificate) {
                    @if (signerItem.isVerifiedBy.sms && !signerItem.hasVerifiableData) {
                      <div class="item-info-label biometry" [ngbTooltip]="tooltipSignatureVerificationRejected">
                        <i class="fal fa-shield-check"></i>
                        {{ 'signature.additionalVerification' | translate }}
                      </div>
                    }

                    @if (signerItem.hasVerifiableData && filterVerifications(signer, this.documentService.allowedManualVerifications)[0]) {
                      <div class="item-info-label biometry failed" [ngbTooltip]="tooltipSignatureVerificationRejected" (click)="verifyBiometryClick.emit(signer)" style="cursor: pointer">
                        <i class="fal fa-shield-check"></i>
                        {{ 'signature.additionalVerification' | translate }}
                      </div>
                    }
                  }
                }
              }
            }
          </div>

          @if (!signer.rejected) {
            @if (
              step.status === SignatureStepStatus.bounce ||
              step.status === SignatureStepStatus.deferred ||
              step.status === SignatureStepStatus.blocked ||
              step.status === SignatureStepStatus.dropped ||
              step.status === SignatureStepStatus.spamreport
            ) {
              <div class="item-info-title">{{ 'signature.deliveryNotReceived.' + (signer.delivery_method | lowercase) | translate }} ({{ 'errorReasons.' + returnErrorReason() | translate }})</div>
            }

            @switch (step.status) {
              @case (SignatureStepStatus.deferred) {
                <div>
                  <p class="emailError__smallDescription">{{ 'signature.notReceivedEmailTemporaryError' | translate }}</p>
                  <div class="emailError__reasonMessage" [innerHTML]="returnEmailErrorMessage(signer.email_events?.reason, 'Deferred')"></div>
                  <p class="emailError__smallDescription">{{ 'signature.at' | translate }} {{ signer.email_events.refused | dateTime }}. {{ 'signature.tryResendEmail' | translate }}</p>
                </div>
              }

              @case (SignatureStepStatus.bounce) {
                <div>
                  <p class="emailError__smallDescription">{{ 'signature.notReceivedEmailError' | translate }}</p>
                  <div class="emailError__reasonMessage" [innerHTML]="returnEmailErrorMessage(signer.email_events.reason, 'Bounce')"></div>
                  <p class="emailError__smallDescription">{{ 'signature.at' | translate }} {{ signer.email_events.refused | dateTime }}</p>
                </div>
              }

              @case (SignatureStepStatus.dropped) {
                <div>
                  <p class="emailError__smallDescription">{{ 'signature.blockedRecipient' | translate }}</p>
                  <div class="emailError__reasonMessage" [innerHTML]="returnEmailErrorMessage(signer.email_events?.reason, 'Dropped')"></div>
                  <p class="emailError__smallDescription">{{ 'signature.at' | translate }} {{ signer.email_events.refused | dateTime }}</p>
                </div>
              }

              @case (SignatureStepStatus.blocked) {
                <div>
                  <p class="emailError__smallDescription">{{ 'signature.blockedRecipientEmailServer' | translate }}</p>
                  <div class="emailError__reasonMessage" [innerHTML]="returnEmailErrorMessage(signer.email_events?.reason, 'Blocked')"></div>
                  <p class="emailError__smallDescription">{{ 'signature.at' | translate }} {{ signer.email_events.refused | dateTime }}</p>
                </div>
              }

              @case (SignatureStepStatus.spamreport) {
                <div>
                  <p class="emailError__smallDescription">{{ 'signature.spamReport' | translate }}</p>
                  <div class="emailError__reasonMessage" [innerHTML]="returnEmailErrorMessage(signer.email_events?.reason, 'Spamreport')"></div>
                  <p class="emailError__smallDescription">{{ 'signature.at' | translate }} {{ signer.email_events.refused | dateTime }}</p>
                </div>
              }

              @case (SignatureStepStatus.cellWhats) {
                <div>
                  <p class="emailError__smallDescription">{{ 'signature.whatsappError' | translate }}</p>
                  <div class="emailError__reasonMessage">{{ getWhatsappErrorReason(signer.email_events.reason) }}</div>
                  <p class="emailError__smallDescription">{{ 'signature.at' | translate }} {{ signer.email_events.refused | dateTime }}</p>
                </div>
              }

              @case (SignatureStepStatus.cellSMS) {
                <div>
                  <p class="emailError__smallDescription">{{ 'signature.carrierError' | translate }}</p>
                  <div class="emailError__reasonMessage">{{ signer.email_events.reason }}</div>
                  <p class="emailError__smallDescription">{{ 'signature.at' | translate }} {{ signer.email_events.refused | dateTime }}</p>
                </div>
              }
            }
          }

          <div class="item-info-descr">
            @switch (step.type) {
              @case (SignatureStepType.emailChange) {
                @for (email of step.previousEmails; track $index) {
                  @if ($index === 0) {
                    {{ 'signature.createdWithEmail' | translate: { email: email } }}
                  } @else if ($index > 0) {
                    <br />
                    {{ 'signature.emailChangedTo' | translate: { email: email } }}
                  }
                }
              }

              @case (SignatureStepType.creation) {
                {{ 'signature.at' | translate }} {{ signer.created_at | dateTime }}
              }

              @case (SignatureStepType.emailDelivery) {
                @if (step.status === SignatureStepStatus.waiting && signerItemisWaitingSortable) {
                  {{ 'signature.signatureOrderActive' | translate }}
                }

                @if (step.status === SignatureStepStatus.waiting && !signerItemisWaitingSortable && (signer.delivery_method !== DeliveryMethodEnum.DeliveryMethodSms || !signer.email_events?.sent)) {
                  {{ 'signature.deliveryStillBeingSent.' + (signer.delivery_method | lowercase) | translate }}
                }

                @if (step.status === SignatureStepStatus.success || step.status === SignatureStepStatus.failed) {
                  {{ 'signature.at' | translate }} {{ signer.email_events?.delivered || signer.email_events?.sent || signer.email_events?.refused || signer.viewed?.created_at | dateTime }}
                }

                @if (signer.email_events?.sent && !signer.email_events?.delivered && signer.delivery_method === DeliveryMethodEnum.DeliveryMethodSms) {
                  {{ 'signature.theSMSWasReceivedByTheCarrier' | translate }}
                }
              }

              @case (SignatureStepType.openEmail) {
                @if (step.status === SignatureStepStatus.waiting) {
                  {{ 'signature.deliveryNotYetOpened.' + (signer.delivery_method | lowercase) | translate }}
                }

                @if (step.status === SignatureStepStatus.success) {
                  {{ 'signature.at' | translate }} {{ signer.email_events?.opened || signer.viewed?.created_at | dateTime }}
                }
              }

              @case (SignatureStepType.toSee) {
                @if (step.status === SignatureStepStatus.waiting) {
                  {{ 'signature.notViewedYetDocument' | translate }}
                }

                @if (step.status === SignatureStepStatus.success) {
                  {{ 'signature.at' | translate }} {{ signer.viewed?.created_at | dateTime }}
                  @if (signer.viewed?.ip && !signerItem.isMarkdownDocumentAndWhatsappFlow) {
                    {{ 'signature.byIP' | translate }} {{ signer.viewed.ip.match(':') ? '[' + signer.viewed.ip + ']' : signer.viewed.ip }}
                    @if (signer.viewed?.port) {
                      :{{ signer.viewed.port }}
                    }
                  } @else {
                    {{ 'signature.viaWhatsapp' | translate }}
                  }

                  @if (signer.viewed?.geolocation && !signerItem.isMarkdownDocumentAndWhatsappFlow) {
                    &nbsp;<i class="fal fa-info-circle" [ngbTooltip]="tooltipGeo" [tooltipContext]="{ geolocation: signer.viewed.geolocation }" placement="left"></i>
                  }
                }
              }

              @case (SignatureStepType.toSign) {
                @if (step.status === SignatureStepStatus.waiting) {
                  {{ 'signature.signNotDone.' + (signer.action.name | lowercase) | translate }}
                }

                @if (step.status === SignatureStepStatus.success || (step.status === SignatureStepStatus.unapproved && signerItem.signatureStatus.isSignedAfterBiometricReset)) {
                  @for (signedStep of [signer.signed || signer.signed_unapproved]; track $index) {
                    {{ 'signature.at' | translate }} {{ signedStep?.created_at | dateTime }}
                    @if (signedStep?.ip && !signerItem.isMarkdownDocumentAndWhatsappFlow) {
                      {{ 'signature.byIP' | translate }} {{ (signedStep.ip.match(':') ? '[' + signedStep.ip + ']' : signedStep.ip) + (signedStep?.port ? ':' + signedStep.port : '') }}
                    } @else {
                      {{ 'signature.viaWhatsapp' | translate }}
                    }

                    @if (signedStep?.geolocation && !signerItem.isMarkdownDocumentAndWhatsappFlow) {
                      &nbsp;
                      <i class="fal fa-info-circle" [ngbTooltip]="tooltipGeo" [tooltipContext]="{ geolocation: signedStep.geolocation }" placement="left"></i>

                      @if (signerItem.hasVerification) {
                        <div>
                          {{ 'signature.additionalVerificationPer' | translate }}

                          <strong>
                            @if (signerItem.isVerifiedBy[SecurityVerificationEnum.Sms]) {
                              <span [innerHTML]="'signature.additionalVerificationSMS' | translate"></span>
                              @if (signerItem.isVerifiedBy[SecurityVerificationEnum.Live] && !signerItem.signatureStatus.isBiometricApproved) {
                                ,
                              }

                              @if (filterVerifications(signer, [SecurityVerificationEnum.Upload, SecurityVerificationEnum.PfFacial]).length > 0 || signerItem.signatureStatus.isBiometricApproved) {
                                {{ 'signature.and' | translate }}
                              }
                            }

                            @if (!signerItem.signatureStatus.isBiometricApproved) {
                              @if (signerItem.isVerifiedBy[SecurityVerificationEnum.Upload]) {
                                <span [innerHTML]="'signature.additionalVerificationUpload' | translate"></span>
                              }

                              @if (signerItem.isVerifiedBy[SecurityVerificationEnum.Live]) {
                                <span [innerHTML]="'signature.additionalVerificationLive' | translate"></span>
                              }

                              @if (signerItem.isVerifiedBy[SecurityVerificationEnum.PfFacial]) {
                                <span [innerHTML]="'signature.additionalVerificationPfFacial' | translate"></span>
                              }

                              @if (signerItem.isVerifiedBy[SecurityVerificationEnum.PfFacialMatch]) {
                                <span [innerHTML]="'signature.additionalVerificationPfFacialMatch' | translate"></span>
                              }

                              @if (signerItem.isVerifiedBy[SecurityVerificationEnum.Manual]) {
                                <span [innerHTML]="'signature.additionalVerificationManual' | translate"></span>
                              }

                              @if (signerItem.isVerifiedBy[SecurityVerificationEnum.BiometricAndTextExtraction]) {
                                <span [innerHTML]="'signature.additionalVerificationBiometricAndTextExtraction' | translate"></span>
                              }

                              @if (signerItem.isVerifiedBy[SecurityVerificationEnum.LivenessAndTextExtraction]) {
                                <span [innerHTML]="'signature.additionalVerificationLivenessAndTextExtraction' | translate"></span>
                              }
                            } @else {
                              <span [innerHTML]="'signature.additionalVerificationManualApproved' | translate"></span>
                            }
                          </strong>
                        </div>
                      }
                    }
                  }
                }
                @if (step.status === SignatureStepStatus.failed) {
                  @for (rejectedStep of [signer.rejected || signer.biometric_rejected || signer.biometric_auto_rejected]; track $index) {
                    {{ 'signature.at' | translate }} {{ rejectedStep?.created_at | dateTime }}

                    @if (rejectedStep?.ip) {
                      {{ 'signature.byIP' | translate }} {{ rejectedStep.ip.match(':') ? '[' + rejectedStep.ip + ']' : rejectedStep.ip }}

                      @if (rejectedStep?.port) {
                        :{{ rejectedStep.port }}
                      }
                    }

                    @if (rejectedStep?.geolocation?.city) {
                      &nbsp;
                      <i class="fal fa-info-circle" [ngbTooltip]="tooltipGeo" [tooltipContext]="{ geolocation: rejectedStep.geolocation }" placement="left"></i>
                    }
                  }
                }
              }
            }
          </div>

          @if (step.status === SignatureStepStatus.failed && signer.rejected?.reason) {
            <span class="item-info-message" [innerHTML]="signer.rejected.reason | nl2br"></span>
          }
        </div>
      </div>
    }
  </div>
</div>

<ng-template #tooltipSignatureVisible>
  <div class="tooltip__descr">{{ 'signature.signatoryVisibleSignature' | translate }}</div>
</ng-template>
<ng-template #tooltipSignatureInvisible>
  <div class="tooltip__descr">{{ 'signature.signatoryInvisibleSignature' | translate }}</div>
</ng-template>
<ng-template #tooltipSignatureVerificationSigned>
  <div class="tooltip__descr">{{ 'signature.documentWithAdditionalVerification' | translate }}</div>
</ng-template>
<ng-template #tooltipSignatureVerificationRejected>
  <div class="tooltip__descr">{{ 'signature.documentRejectedByAdditionalVerification' | translate }}</div>
</ng-template>
<ng-template #tooltipGeo let-geolocation="geolocation">
  <div class="tooltip__descr">
    <strong>{{ 'signature.IPLocation' | translate }}</strong>
    <br />
    {{ geolocation.city }}, {{ geolocation.stateISO }} - {{ geolocation.country }}
  </div>
</ng-template>
